export const Main = r => require.ensure([], () => r(require('../../Core/components/Main')), 'Financial-bundle')
export const ListTransacoes = r => require.ensure([], () => r(require('../../Financial/components/Transactions/ListTransacoes')), 'Financial-bundle')
export const ListMarketplaceReceivables = r => require.ensure([], () => r(require('../../Financial/components/MarketplaceReceivables/ListMarketplaceReceivables')), 'Financial-bundle')
export const MakePaymentReceivable = r => require.ensure([], () => r(require('../../Financial/components/MarketplaceReceivables/MakePaymentReceivable')), 'Financial-bundle')
export const ListAnticipationSchedules = r => require.ensure([], () => r(require('../../Financial/components/AnticipationSchedules/ListAnticipationSchedules')), 'Financial-bundle')
export const AddAnticipationSchedules = r => require.ensure([], () => r(require('../../Financial/components/AnticipationSchedules/AddAnticipationSchedules')), 'Financial-bundle')
export const ShowAnticipationSchedules = r => require.ensure([], () => r(require('../../Financial/components/AnticipationSchedules/ShowAnticipationSchedules')), 'Financial-bundle')
export const ListReceivables = r => require.ensure([], () => r(require('../../Financial/components/Receivables/ListReceivables')), 'Financial-bundle')
export const ListReceivablesV3 = r => require.ensure([], () => r(require('../../Financial/components/ReceivablesV3/ListReceivables')), 'Financial-bundle')
export const ViewTransacoes = r => require.ensure([], () => r(require('../../Financial/components/Transactions/ViewTransacoes')), 'Financial-bundle')
export const ListTransacoesV3 = r => require.ensure([], () => r(require('../../Financial/components/TransactionsV3/ListTransacoes')), 'Financial-bundle')
export const ViewTransacoesV3 = r => require.ensure([], () => r(require('../../Financial/components/TransactionsV3/ViewTransacoes')), 'Financial-bundle')
export const ListPaymentExport = r => require.ensure([], () => r(require('../../Financial/components/PaymentExport/ListPaymentExport')), 'Financial-bundle')
export const ViewPaymentExport = r => require.ensure([], () => r(require('../../Financial/components/PaymentExport/ViewPaymentExport')), 'Financial-bundle')
export const ListPaymentSplitEC = r => require.ensure([], () => r(require('../../Financial/components/PaymentSplitEC/ListPaymentSplitEC')), 'Financial-bundle')
export const ViewPaymentSplitEC = r => require.ensure([], () => r(require('../../Financial/components/PaymentSplitEC/ViewPaymentSplitEC')), 'Financial-bundle')
export const ListPaymentSplitMarketplace = r => require.ensure([], () => r(require('../../Financial/components/PaymentSplitMarketplace/ListPaymentSplitMarketplace')), 'Financial-bundle')
export const ViewPaymentSplitMarketplace = r => require.ensure([], () => r(require('../../Financial/components/PaymentSplitMarketplace/ViewPaymentSplitMarketplace')), 'Financial-bundle')
export const ListLogTransactions = r => require.ensure([], () => r(require('../../Financial/components/LogTransactions/ListLogTransactions')), 'Financial-bundle')
export const ListSendDimp = r => require.ensure([], () => r(require('../../Financial/components/SendDimp/ListSendDimp')), 'Financial-bundle')
export const ListTransactionsRisk = r => require.ensure([], () => r(require('../../Financial/components/TransactionsRisk/ListTransactionsRisk')), 'Financial-bundle')
export const ListTransactionsOnlineRisk = r => require.ensure([], () => r(require('../../Financial/components/TransactionsOnlineRisk/ListTransactionsOnlineRisk')), 'Financial-bundle')
export const ListTransactionsRiskV3 = r => require.ensure([], () => r(require('../../Financial/components/TransactionsRiskV3/ListTransactionsRisk')), 'Financial-bundle')
export const ListPaymentConfigAdjust = r => require.ensure([], () => r(require('../../Financial/components/PaymentAdjust/ListPaymentConfigAdjust')), 'Financial-bundle')
export const EditNewPaymentAdjust = r => require.ensure([], () => r(require('../../Financial/components/PaymentAdjust/EditNewPaymentAdjust')), 'Financial-bundle')
export const ListDepositsV3 = r => require.ensure([], () => r(require('../../DepositsV3/components/ListDeposits')), 'Financial-bundle')
export const ViewMarkupRepresentante = r => require.ensure([], () => r(require('../../FinancialManagement/components/Payment/ViewMarkupRepresentante')), 'Financial-bundle')
export const ListPagamentosMarkup = r => require.ensure([], () => r(require('../../Financial/components/PagamentosMarkup/ListPagamentosMarkup')), 'Financial-bundle')
export const FormLinkPayment = r => require.ensure([], () => r(require('../components/PaymentLink/FormPaymentLink.vue')), 'Financial-bundle')
export const ListPaymentLink = r => require.ensure([], () => r(require('../../Financial/components/PaymentLink/ListPaymentLink')), 'Financial-bundle')
export const ListPaymentBankSlipBatche = r => require.ensure([], () => r(require('../../Financial/components/PaymentBankSlipBatche/ListPaymentBankSlipBatche')), 'Financial-bundle')
// export const ViewDeposits = r => require.ensure([], () => r(require('../../Deposits/components/ViewDeposits')), 'Financial-bundle')

const children = [
  {
    name: 'financial.anticipationSchedules.index',
    path: 'antecipacao-agenda',
    component: ListAnticipationSchedules,
    meta: {
      requiresAuth: true,
      title: 'Antecipação de Recebíveis',
      titleMenu: 'Antecipação de Recebíveis',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Antecipação de Recebíveis',
          pathName: 'financial.anticipationSchedules.index'
        },
      ]
    }
  },
  {
    name: 'financial.anticipationSchedule.create',
    path: 'antecipacao-agenda/adicionando',
    component: AddAnticipationSchedules,
    meta: {
      requiresAuth: true,
      title: 'Adicionando Antecipação de Recebíveis',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Antecipação de Recebíveis',
          pathName: 'financial.anticipationSchedules.index'
        },
        {
          name: 'Adicionando Antecipação de Recebíveis',
          pathName: 'financial.anticipationSchedules.create'
        },
      ]
    }
  },
  {
    name: 'financial.anticipationSchedule.show',
    path: 'antecipacao-agenda/:id',
    component: ShowAnticipationSchedules,
    meta: {
      requiresAuth: true,
      title: 'Descrição da Antecipação de Recebíveis',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Antecipação de Recebíveis',
          pathName: 'financial.anticipationSchedules.index'
        },
        {
          name: 'Descrição da Antecipação de Recebíveis',
          pathName: 'financial.anticipationSchedules.show'
        },
      ]
    }
  },
  {
    name: 'financial.receivable.index',
    path: 'recebiveis',
    component: ListReceivables,
    meta: {
      requiresAuth: true,
      title: 'Listagem de Recebíveis',
      titleMenu: 'Recebíveis',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Recebíveis',
          pathName: 'financial.receivable.index'
        },
      ]
    }
  },
  {
    name: 'financial.marketplace_receivable.index',
    path: 'marketplace-recebiveis',
    component: ListMarketplaceReceivables,
    meta: {
      requiresAuth: true,
      title: 'Listagem de Recebíveis de Marketplace',
      titleMenu: 'Recebíveis de Marketplace',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Listagem de Recebíveis de Marketplace',
          pathName: 'financial.marketplace_receivable.index'
        },
      ]
    }
  },
  {
    name: 'financial.marketplace_receivable.update',
    path: 'marketplace-recebiveis-payment',
    component: MakePaymentReceivable,
    meta: {
      requiresAuth: true,
      title: 'Realizar Pagamento de Recebíveis',
      titleMenu: 'Recebíveis de Marketplace',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Listagem de Recebíveis de Marketplace',
          pathName: 'financial.marketplace_receivable.index'
        },
        {
          name: 'Realizar Pagamento de Recebíveis',
          pathName: 'financial.marketplace_receivable.update'
        },
      ]
    }
  },
  {
    name: 'financial.receivablev3.index',
    path: 'recebiveisv3',
    component: ListReceivablesV3,
    meta: {
      requiresAuth: true,
      title: 'Listagem de Recebíveis (MongoDB)',
      titleMenu: 'Recebíveis MongoDB',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Listagem de Recebíveis (MongoDB)',
          pathName: 'financial.receivablev3.index'
        },
      ]
    }
  },

  {
    name: 'financial.depositv3.index',
    path: 'depositosv3',
    component: ListDepositsV3,
    meta: {
      requiresAuth: true,
      title: 'Agenda Financeira (MongoDB)',
      titleMenu: 'Agenda Financeira MongoDB',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Listagem de Agenda Financeira (MongoDB)',
          pathName: 'financial.depositv3.index'
        },
      ]
    }
  },
  {
    name: 'financial.paymentConfigAdjust.index',
    path: 'configurar-ajuste-financeiro',
    component: ListPaymentConfigAdjust,
    meta: {
      requiresAuth: true,
      title: 'Configurar Lançamentos Financeiros',
      titleMenu: 'Configurar Lançamentos Financeiros',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Configurar Lançamentos financeiros',
          pathName: 'financial.paymentConfigAdjust.index'
        },
      ]
    }
  },
  {
    name: 'financial.paymentLink.index',
    path: 'link-pagamento',
    component: ListPaymentLink,
    meta: {
      requiresAuth: true,
      title: 'Links de Pagamento',
      titleMenu: 'Links de Pagamento',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Listagem Links de Pagamento ',
          pathName: 'financial.paymentLink.index'
        },
      ]
    }
  },
  {
    name: 'financial.paymentLink.edit',
    path: 'link-pagamento/:id',
    component: FormLinkPayment,
    meta: {
      requiresAuth: true,
      title: 'Link de Pagamento',
      titleMenu: 'Link de Pagamento',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Listagem Links de Pagamento ',
          pathName: 'financial.paymentLink.index'
        },
        {
          name: 'Editando Link de Pagamento ',
          pathName: 'financial.paymentLink.edit'
        },
      ]
    }
  },
  {
    name: 'financial.paymentLink.new',
    path: 'cadastrar-link-pagamento',
    component: FormLinkPayment,
    meta: {
      requiresAuth: true,
      title: 'Cadastrar Links de Pagamento',
      titleMenu: 'Cadastrar Links de Pagamento',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Listagem Links de Pagamento ',
          pathName: 'financial.paymentLink.index'
        },
        {
          name: 'Cadastrar Links de Pagamento ',
          pathName: 'financial.paymentLink.new'
        },
      ]
    }
  },
  {
    name: 'financial.paymentAdjust.create',
    path: 'ajuste-financeiro/adicionando',
    component: EditNewPaymentAdjust,
    meta: {
      requiresAuth: true,
      title: 'Adicionando Lançamentos Financeiros',
      titleMenu: 'Pagamentos',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Configurar Lançamentos Financeiros',
          pathName: 'financial.paymentConfigAdjust.index'
        },
        {
          name: 'Adicionando Lançamentos Financeiros',
          pathName: 'financial.paymentAdjust.view'
        },
      ]
    }
  },
  {
    name: 'financial.paymentAdjust.view',
    path: 'ajuste-financeiro/:id',
    component: EditNewPaymentAdjust,
    meta: {
      requiresAuth: true,
      title: 'Visualizando Lançamentos Financeiros',
      titleMenu: 'Pagamentos',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Lançamentos Financeiros',
          pathName: 'financial.paymentAdjust.index'
        },
        {
          name: 'Editando Lançamento Financeiro',
          pathName: 'financial.paymentAdjust.view'
        },
      ]
    }
  },
  {
    name: 'financial.payment_ec_split.index',
    path: 'pagamentos-split',
    component: ListPaymentSplitEC,
    meta: {
      requiresAuth: true,
      title: 'Listagem Lote de Pagamentos via Split EC',
      titleMenu: 'Pagamentos via Split EC',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Lote de Pagamentos via Split EC',
          pathName: 'financial.payment_ec_split.index'
        },
      ]
    }
  },
  {
    name: 'financial.payment_ec_split.view',
    path: 'pagamentos-split/:id',
    component: ViewPaymentSplitEC,
    meta: {
      requiresAuth: true,
      title: 'Visualizando Pagamento via Split EC',
      titleMenu: 'Lote de Pagamentos via Split EC',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Lote de Pagamentos via Split EC',
          pathName: 'financial.payment_ec_split.index'
        },
        {
          name: 'Visualizando Lote de Pagamento via Split EC',
          pathName: 'financial.payment_ec_split.view'
        },
      ]
    }
  },
  {
    name: 'financial.payment_marketplace_split.index',
    path: 'split-marketplace',
    component: ListPaymentSplitMarketplace,
    meta: {
      requiresAuth: true,
      title: 'Listagem Lote de Pagamentos Split Marketplace',
      titleMenu: 'Pagamentos Split Marketplace',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Lote de Pagamentos Split Marketplace',
          pathName: 'financial.payment_marketplace_split.index'
        },
      ]
    }
  },
  {
    name: 'financial.payment_marketplace_split.view',
    path: 'split-marketplace/:id',
    component: ViewPaymentSplitMarketplace,
    meta: {
      requiresAuth: true,
      title: 'Visualizando Pagamento Split Marketplace',
      titleMenu: 'Lote de Pagamentos Split Marketplace',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Lote de Pagamentos Split Marketplace',
          pathName: 'financial.payment_marketplace_split.index'
        },
        {
          name: 'Visualizando Lote de Pagamento Split Marketplace',
          pathName: 'financial.payment_marketplace_split.view'
        },
      ]
    }
  },

  {
    name: 'financial.paymentExport.index',
    path: 'pagamento-exportados',
    component: ListPaymentExport,
    meta: {
      requiresAuth: true,
      title: 'Listagem de Pagamentos Exportados',
      titleMenu: 'Pagamentos Exportados',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Listagem de Pagamentos Exportados',
          pathName: 'financial.paymentExport.index'
        },
      ]
    }
  },
  {
    name: 'financial.paymentExport.view',
    path: 'pagamento-exportados/:id',
    component: ViewPaymentExport,
    meta: {
      requiresAuth: true,
      title: 'Visualizando Pagamentos Exportados',
      titleMenu: 'Transações',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Listagem de Pagamentos Exportados',
          pathName: 'financial.paymentExport.index'
        },
        {
          name: 'Visualizando Pagamentos Exportados',
          pathName: 'financial.paymentExport.view'
        },
      ]
    }
  },
  {
    name: 'financial.payment_bank_slip_batche.index',
    path: 'payment_bank_slip_batche',
    component: ListPaymentBankSlipBatche,
    meta: {
      requiresAuth: true,
      title: 'Listagem Lote de Pagamentos Boleto',
      titleMenu: 'Pagamentos Boleto',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Lote de Pagamentos Boleto',
          pathName: 'financial.payment_bank_slip_batche.index'
        },
      ]
    }
  },
  {
    name: 'financial.logTransation.index',
    path: 'log-transacoes',
    component: ListLogTransactions,
    meta: {
      requiresAuth: true,
      title: 'Listagem de logs Transações',
      titleMenu: 'Logs de Transações',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Listagem Logs de Transações',
          pathName: 'financial.logTransation.index'
        },
      ]
    }
  },
  {
    name: 'financial.send-dimp.index',
    path: 'send-dimp',
    component: ListSendDimp,
    meta: {
      requiresAuth: true,
      title: 'Listagem de ecs que vão para Dimp',
      titleMenu: 'Ecs que vão para Dimp',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Ecs que vão para Dimp',
          pathName: 'financial.send-dimp.index'
        },
      ]
    }
  },

  {
    name: 'financial.transationrisk.index',
    path: 'transacoes-em-risco',
    component: ListTransactionsRisk,
    meta: {
      requiresAuth: true,
      title: 'Listagem de Transações em Risco',
      titleMenu: 'Transações em Risco',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Listagem de Transações em Risco',
          pathName: 'financial.transationrisk.index'
        },
      ]
    }
  },
  {
    name: 'financial.transationonlinerisk.index',
    path: 'transacoes-online-em-risco',
    component: ListTransactionsOnlineRisk,
    meta: {
      requiresAuth: true,
      title: 'Listagem de Transações Online em Risco',
      titleMenu: 'Transações Online em Risco',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Listagem de Transações Online em Risco',
          pathName: 'financial.transationonlinerisk.index'
        },
      ]
    }
  },

  {
    name: 'financial.transationriskv3.index',
    path: 'transacoes-em-riscov3',
    component: ListTransactionsRiskV3,
    meta: {
      requiresAuth: true,
      title: 'Listagem de Transações em Risco (MongoDB)',
      titleMenu: 'Transações em Risco MongoDB',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Listagem de Transações em Risco MongoDB',
          pathName: 'financial.transationriskv3.index'
        },
      ]
    }
  },

  {
    name: 'financial.transation.index',
    path: 'transacoes',
    component: ListTransacoes,
    meta: {
      requiresAuth: true,
      title: 'Listagem de Transações',
      titleMenu: 'Transações',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Listagem de Transações',
          pathName: 'financial.transation.index'
        },
      ]
    }
  },
  {
    name: 'financial.transationv3.index',
    path: 'transacoesv3',
    component: ListTransacoesV3,
    meta: {
      requiresAuth: true,
      title: 'Listagem de Transações (MongoDB)',
      titleMenu: 'Transações MongoDB',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Listagem de Transações MongoDB',
          pathName: 'financial.transationv3.index'
        },
      ]
    }
  },
  {
    name: 'financial.transationv3.view',
    path: 'transacoesv3/:id',
    component: ViewTransacoesV3,
    meta: {
      requiresAuth: true,
      title: 'Visualizando Transação (V3)',
      titleMenu: 'Transações V3',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Listagem de Transações V3',
          pathName: 'financial.transationv3.index'
        },
        {
          name: 'Visualizando V3',
          pathName: 'financial.transationv3.view'
        },
      ]
    }
  },
  {
    name: 'financial.transation.view',
    path: 'transacoes/:id',
    component: ViewTransacoes,
    meta: {
      requiresAuth: true,
      title: 'Visualizando Transação',
      titleMenu: 'Transações',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Listagem de Transações',
          pathName: 'financial.transation.index'
        },
        {
          name: 'Visualizando',
          pathName: 'financial.transation.view'
        },
      ]
    }
  },
  {
    name: 'financial.pagamentoMaketplace.index',
    path: 'markup-markeplace',
    component: ListPagamentosMarkup,
    meta: {
      requiresAuth: true,
      title: 'Visualizando Transação',
      titleMenu: 'Markup de Marketplace',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Markup de Marketplace',
          pathName: 'financial.pagamentoMaketplace.index'
        },
      ]
    }
  },
  {
    name: 'financial.markupRepresentante.index',
    path: 'markup-representante',
    component: ViewMarkupRepresentante,
    meta: {
      requiresAuth: true,
      title: 'Visualizando Transação',
      titleMenu: 'Markup de Representante',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Markup de Representante',
          pathName: 'financial.markupRepresentante.index'
        },
      ]
    }
  },
]

export default [{
  name: 'financial',
  children,
  path: '/financeiro',
  component: Main,
  redirect: { name: 'home.index' },
  meta: {
    requiresAuth: true,
  }
}]
